import { render, staticRenderFns } from "./Favourites_wrap.vue?vue&type=template&id=6fdf412c"
import script from "./Favourites_wrap.vue?vue&type=script&lang=js"
export * from "./Favourites_wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports